<template>
  <div>
    <div id="receiptDataBill" class="card-body print-form">
      <b-row class="">
        <b-col cols="12">
          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span>
                  <h6
                    class="
                      mb-0
                      tx-rubik
                      text-center
                      company_name
                      text-uppercase
                      shop-header
                      siteName
                    "
                  >
                    {{ GetSiteName }}
                  </h6>
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <h6 class="mt-0 mb-0 tx-rubik tx-12 text-center">
                  {{
                    GetShopInfo.address
                      ? GetShopInfo.address.address_line1
                      : ""
                  }},
                  {{
                    GetShopInfo.address
                      ? GetShopInfo.address.address_line2
                      : ""
                  }}, {{ GetShopInfo.address ? GetShopInfo.address.city : "" }},
                  {{
                    GetShopInfo.address ? GetShopInfo.address.country.name : ""
                  }}
                </h6>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <h6 class="mt-0 tx-12 tx-rubik text-center">
                  {{ GetShopInfo.contact ? GetShopInfo.contact.telephone : "" }}
                  |
                  {{ GetShopInfo.contact ? GetShopInfo.contact.phone : "" }}
                </h6>
              </td>
            </tr>
          </table>

          <hr class="hor_line" />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold">
          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  <!-- Customer -->
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  <!-- {{ customer.name }} -->
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Date
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ new Date() | formatDateTime }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Biller
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ GetUserName }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Reference
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ GetAddedSale.reference_number }}
                </span>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <hr style="b margin-bottom: 10px" />

      <b-row>
        <b-col>
          <table style="width: 400px; margin: 0px 5px">
            <thead>
              <tr style="border-bottom: solid 2px">
                <th class="description" style="color: black; text-align: left">
                  Item
                </th>
                <th
                  class="unit-price unit-price-text"
                  style="color: black; text-align: right"
                >
                  price
                </th>
                <th
                  class="quantity"
                  style="color: black; text-align: center; padding: 0px"
                >
                  Qty
                </th>
                <th class="discount" style="color: black; text-align: right">
                  Discount
                </th>
                <th
                  class="amount unit-price-text"
                  style="color: black; text-align: right"
                >
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(product, index) in GetPrintProductsData"
                :key="index"
                style="border-top: dashed 1px"
              >
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 110px;
                  "
                >
                  <span class="tx-bold mb-2 f-15" style="color: black"
                    >{{ product.name }}
                  </span>
                  -
                  {{ product.unit.name }}
                </td>
                <td
                  class="unit-price"
                  style="color: black; text-align: right; width: 80px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik unit-price-text"
                  >
                    {{ product.price | amount }}
                  </span>
                </td>
                <td
                  class="quantity"
                  style="color: black; text-align: center; width: 30px"
                >
                  <span
                    style="color: black; text-align: center"
                    class="tx-rubik"
                  >
                    {{ product.quantity }}
                  </span>
                </td>
                <td
                  class="discount"
                  style="color: black; text-align: right; width: 80px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik unit-price-text"
                  >
                    {{
                      product.batch.isBargained
                        ? product.batch.bargained_amount * product.quantity
                        : 0 | amount
                    }}
                  </span>
                </td>
                <td
                  class="amount"
                  style="color: black; text-align: right; width: 100px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik unit-price-text"
                  >
                    {{
                      product.batch.isBargained
                        ? product.quantity *
                          (product.price - product.batch.bargained_amount)
                        : (product.quantity * product.price) | amount
                    }}
                  </span>
                </td>
              </tr>

              <tr
                v-for="(item, index) in GetPrintServicesData"
                :key="index"
                style="border-top: dashed 1px"
              >
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 110px;
                  "
                >
                  <span class="tx-bold mb-2 f-15" style="color: black"
                    >{{ item.name ? item.name : item.service.code }}
                  </span>
                </td>
                <td
                  class="unit-price"
                  style="color: black; text-align: right; width: 80px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik unit-price-text"
                  >
                    {{ item.amount ? item.amount : 0 | amount }}
                  </span>
                </td>
                <td
                  class="quantity"
                  style="color: black; text-align: center; width: 30px"
                >
                  --
                </td>
                <td
                  class="discount"
                  style="color: black; text-align: right; width: 80px"
                >
                  {{
                    item.bargain_discount ? item.bargain_discount : 0 | amount
                  }}
                </td>
                <td
                  class="amount"
                  style="color: black; text-align: right; width: 100px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik unit-price-text"
                  >
                    {{ item.amount | amount }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td
                colspan="2"
                class="description"
                style="color: black; text-align: left"
              >
                <hr style="border-top: solid 1px; margin: 1px" />

                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  No of items - {{ products.length }}
                </span>
              </td>
              <!-- <td class="unit-price" style="color: black; text-align: right">
                           <hr style="border-top: solid 1px; margin: 1px" />

              <span class="tx-rubik" style="color: black">
                {{ products.length }}
              </span>
            </td> -->
            </tr>
            <tr>
              <td
                class="description"
                style="color: black; text-align: left; padding-top: 10px"
              >
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Subtotal
                </span>
              </td>
              <td
                class="unit-price"
                style="color: black; text-align: right; padding-top: 10px"
              >
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{
                    (GetDiscountAmount +
                      GetTotalAmount +
                      GetServiceTotalAmount)
                      | amount
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Discount
                </span>

                <hr style="border-top: solid 1px; margin: 1px" />
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ totalDiscount | amount }}
                </span>

                <hr style="border-top: solid 1px; margin: 1px" />
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Net Amount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ totalAmountMinusCustomerDiscount | amount }}
                </span>
              </td>
            </tr>

            <tr>
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Received Amount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ GetPrintCustomerManualAmount | amount }}
                </span>
              </td>
            </tr>

            <!-- <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left; font-weight: bold">
                  Additional Discount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ GetPrintTotalDiscount | amount }}
                </span>
              </td>
            </tr> -->

            <tr
              v-if="
                parseFloat(GetPrintCustomerChequeAmount) != 0 ||
                  parseFloat(GetPrintCustomerCardAmount) != 0
              "
            >
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Pay with Cash
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ GetPrintCustomerCashAmount | amount }}
                </span>
              </td>
            </tr>

            <tr v-if="parseFloat(GetPrintCustomerCardAmount) > 0">
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Pay with Card
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ GetPrintCustomerCardAmount | amount }}
                </span>
              </td>
            </tr>

            <tr v-if="GetPrintCustomerChequeAmount > 0">
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Pay with Cheque
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ GetPrintCustomerChequeAmount | amount }}
                </span>
              </td>
            </tr>

            <tr>
              <td class="description" style="color: black; text-align: left">
                <hr style="border-top: dashed 1px; margin: 1px" />
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Balance
                </span>
                <hr style="border-top: dashed 1px; margin: 1px" />
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <hr style="border-top: dashed 1px; margin: 1px" />
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ GetPrintBalance | amount }}
                </span>
                <hr style="border-top: dashed 1px; margin: 1px" />
              </td>
            </tr>
            <tr style="margin-top: 10px">
              <td colspan="2" style="margin-top: 20px">
                <h4 style="text-align: center; margin-top: 20px; color: black">
                  <!-- நன்றி மீண்டும் வருக ! -->
                  Thank You Come Again!
                </h4>
              </td>
            </tr>

            <tr style="margin-top: 10px">
              <td colspan="2" style="margin-top: 20px">
                <a
                  href="https://nallaienterprise.com/"
                  style="
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    color: black;
                  "
                >
                  https://nallaienterprise.com/
                </a>
              </td>
            </tr>
            <tr>
              <td
                colspan="2"
                style="
                  font-size: 12px;
                  padding-top: 20px;
                  color: black;
                  text-align: center;
                "
              >
                Powered by SpeedCodeLabs (Pvt) Ltd | 0212 211 599
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </div>

    <!-- <div class="card-body p-2" style="width:80mm;height:300mm" id="receiptData">
      <b-row class="">
        <b-col cols="12">
          <h1 class="mb-0 tx-rubik text-center company_name text-uppercase">
            {{ GetShopInfo.name }}
          </h1>
          <h6 class="mt-0 mb-0 tx-rubik tx-12 text-center">
            {{ GetShopInfo.address ? GetShopInfo.address.address_line1 : "" }},
            {{ GetShopInfo.address ? GetShopInfo.address.address_line2 : "" }},
            {{ GetShopInfo.address ? GetShopInfo.address.city : "" }},
            {{ GetShopInfo.address ? GetShopInfo.address.country.name : "" }}
          </h6>
          <h6 class="mt-0 tx-12 tx-rubik text-center">
            {{ GetShopInfo.contact ? GetShopInfo.contact.telephone : "" }} |
            {{ GetShopInfo.contact ? GetShopInfo.contact.phone : "" }}
          </h6>
        </b-col>
      </b-row>
      <hr class="hor_line" />
      <b-row>
        <b-col class="font-weight-bold">
          <ul class="list-group list-group-flush mg-b-0 tx-13">
            <li
              class="list-group-item bill_width pd-x-0  justify-content-between bottom-line"
            >
              <div class="d-flex justify-content-between">
                <span class="tx-rubik">
                  Customer
                </span>
                <span class="tx-rubik">
                  {{ customer.name }}
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="tx-rubik">
                  Date
                </span>
                <span class="tx-rubik">
                  {{ new Date() | formatDateTime }}
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="tx-rubik">
                  Biller
                </span>
                <span class="tx-rubik">
                  {{ GetUserName }}
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="tx-rubik">
                  Reference
                </span>
                <span class="tx-rubik"> #Ref-012354 </span>
              </div>
            </li>
          </ul>
        </b-col>
      </b-row>

      <b-row>
        <b-col>

          <ul class="list-group list-group-flush  tx-13">
            <li class="list-group-item bill_width   justify-content-between">
              <span class="tx-bold mb-2 f-15">Product Name</span> - unit

              <div class="d-flex justify-content-between">
                <span class="tx-rubik tx-bold italic"> Unit price </span>
                <span class="tx-rubik tx-bold italic"> Qty </span>
                <span class="tx-rubik tx-bold italic"> Discount </span>
                <span class="tx-rubik tx-bold italic"> Amount </span>
              </div>
            </li>
            <hr style="border-top: dashed 1px;margin:1px" />
          </ul>
          <ul class="list-group list-group-flush tx-13">
            <li
              v-for="(product, index) in products"
              :key="index"
              class="list-group-item bill_width pd-x-0  justify-content-between "
            >
              <span class="tx-bold mb-2 f-15">{{ product.name }} </span> -
              {{ product.unit.name }}

              <div class="d-flex justify-content-between">
                <span class="tx-rubik">
                  {{ product.price | amount }}
                </span>
                <span class="tx-rubik">
                  {{ product.quantity }}
                </span>
                <span class="tx-rubik">
                  {{
                    product.batch.isBargained
                      ? product.batch.bargained_amount
                      : 0 | amount
                  }}
                </span>
                <span class="tx-rubik">
                  {{
                    product.batch.isBargained
                      ? product.quantity *
                        (product.price - product.batch.bargained_amount)
                      : (product.quantity * product.price) | amount
                  }}
                </span>
              </div>
            </li>
            <hr style="border-top: dashed 1px;margin:1px" />
          </ul>
          <ul class="list-group list-group-flush mg-b-0 tx-13">
            <li class="list-group-item bill_width   justify-content-between ">
              <div class="d-flex justify-content-between">
                <span class="tx-rubik">
                  No of items
                </span>
                <span class="tx-rubik">
                  {{ products.length }}
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="tx-rubik">
                  Total
                </span>
                <span class="tx-rubik">
                  {{ (GetDiscountAmount + GetTotalAmount) | amount }}
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="tx-rubik">
                  Discount
                </span>
                <span class="tx-rubik">
                  {{ GetDiscountAmount | amount }}
                </span>
              </div>
              <hr style="border-top: 1px solid black;margin:1px" />
              <div class="d-flex justify-content-between mb-4">
                <span class="tx-rubik">
                  Net Amount
                </span>
                <span class="tx-rubik">
                  {{ GetTotalAmount | amount }}
                </span>
              </div>

              <div class="d-flex justify-content-between">
                <span class="tx-rubik">
                  Cash
                </span>
                <span class="tx-rubik">
                  {{ GetCustomerManualAmount | amount }}
                </span>
              </div>
              <div
                class="d-flex justify-content-between"
                v-if="
                  parseFloat(GetCustomerChequeAmount) != 0 ||
                    parseFloat(GetCustomerCardAmount) != 0
                "
              >
                <span class="tx-rubik">
                  Pay with Cash
                </span>
                <span class="tx-rubik">
                  {{ GetCustomerCashAmount | amount }}
                </span>
              </div>
              <div
                class="d-flex justify-content-between"
                v-if="parseFloat(GetCustomerCardAmount) > 0"
              >
                <span class="tx-rubik">
                  Pay with Card
                </span>
                <span class="tx-rubik">
                  {{ GetCustomerCardAmount | amount }}
                </span>
              </div>
              <div
                class="d-flex justify-content-between"
                v-if="GetCustomerChequeAmount > 0"
              >
                <span class="tx-rubik">
                  Pay with Cheque
                </span>
                <span class="tx-rubik">
                  {{ GetCustomerChequeAmount | amount }}
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="tx-rubik">
                  Balance
                </span>
                <span class="tx-rubik">
                  {{ Balance | amount }}
                </span>
              </div>
            </li>
          </ul>
          <hr style="border-top: dashed 1px;margin:1px" />
          <div>
            <p class="h6 mt-2 text-center">
              <strong>Thank You Come Again!</strong>
            </p>
          </div>
        </b-col>
      </b-row>
    </div> -->

    <toggle-button
      class="float-right"
      :value="isA4Size"
      v-model="isA4Size"
      :width="73"
      :height="25"
      :font-size="11"
      :color="{ checked: '#007bff', unchecked: '#b2b2b2', disabled: '#CCCCCC' }"
      :labels="{ checked: 'A4', unchecked: 'Default' }"
    />

    <b-btn
      variant="primary"
      class="mt-2 pt-2 pb-2 font-poppins font-weight-bold w-100"
      @click="print"
    >
      Print
    </b-btn>
    <!-- :disabled="!GetIsSubmittedSale" -->
    <PrintBillA4 v-show="false" ref="a4Print" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import BillTemplate from "./BillTemplate";
import PrintBillA4 from "./PrintBillA4";
export default {
  name: "PrintBill",
  components: {
    BillTemplate,
    PrintBillA4,
  },
  props: {},
  data: () => ({
    isA4Size: false,
  }),

  computed: {
    ...mapState("bill", ["products", "customer"]),
    ...mapGetters("bill", [
      "GetTotalAmount",
      "GetDiscountAmount",
      "GetProductsCount",
      "GetPrintProductsData",
      "GetPrintServicesData",
      "GetPrintCustomerCashAmount",
      "GetPrintCustomerCardAmount",
      "GetPrintCustomerManualAmount",
      "GetPrintCustomerChequeAmount",
      "GetPrintTotalDiscount",
      "GetPrintBalance",
      "GetAddedSale",
      "GetIsSubmittedSale",
      "GetServiceTotalAmount",
    ]),
    ...mapGetters("shops", ["GetShopInfo"]),

    ...mapGetters("auth", ["GetUserName"]),

    ...mapGetters("siteSettings", ["GetSiteName"]),

    totalDiscount() {
      return (
        parseFloat(this.GetDiscountAmount || 0) +
        parseFloat(this.GetPrintTotalDiscount || 0)
      );
    },

    totalAmountMinusCustomerDiscount() {
      const total =
        parseFloat(this.GetTotalAmount || 0) +
        parseFloat(this.GetServiceTotalAmount || 0);
      const discount = parseFloat(this.GetPrintTotalDiscount || 0);
      return total - discount;
    },

    // cardAmount: function() {
    //   if (this.GetCustomerCardAmount) {
    //     return this.GetCustomerCardAmount;
    //   } else {
    //     return 0;
    //   }
    // },
  },
  methods: {
    print() {
      if (this.isA4Size == false) {
        setTimeout(() => {
          this.$htmlToPaper("receiptDataBill");
        }, 100000);
      } else {
        this.$refs.a4Print.printa4size();
      }
      setTimeout(() => {
        this.$store.dispatch("bill/cancelBill");
      }, 2000);
    },
  },
};
</script>
<style>
.description,
.description {
  width: 80px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.siteName {
  font-size: 14px;
  font-weight: 700;
}

.unit-price,
.unit-price {
  width: 90px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.unit-price-text {
  text-align: right;
}

.quantity,
.quantity {
  width: 40px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.discount,
.discount {
  width: 90px;
  word-break: break-all;
  padding: 0px 10px;
}

.amount,
.amount {
  width: 100px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.centered {
  text-align: center;
  align-content: center;
}

.ticket {
  width: 155px;
  max-width: 155px;
}

img {
  max-width: inherit;
  width: inherit;
}

#receiptData {
  width: 100%;
  background: white;
}
</style>
